import React, {Component} from 'react'
import PropTypes from 'prop-types'
import IdeaOwner from '../components/IdeaOwner'
import './css/StoredListItem.css'

let ideaRowStyle = {
    backgroundColor: '#ffffff',
    color: '#000000',
    height: 55+'px',
}

class StoredListItem extends Component {
    render() {
        if(!this.props.item)
            return null
        var name = this.props.item.ownerName ? this.props.item.ownerName : this.props.item.owner
        var url = this.props.item.ownerPhotoURL ? this.props.item.ownerPhotoURL : ''
        if (this.props.item.hasOwnProperty('responsible')){
            url = this.props.item.responsible.photoURL
            name = this.props.item.responsible.fullName
        }

        return (

            <div className='row idea' style={ideaRowStyle}>
                <div>
                    <div>
                        <div className='divStoredStyleTitle'>
                            <h4 className='storedIdeaTitle'>
                            {this.props.item.name}
                            </h4>
                        </div>
                        <div className='divStoredStyleProfile'>
                            {this.props.showFields.includes('owner') &&
                                <div className='StoredListProfile'>
                                    <IdeaOwner
                                        ownerName={name}
                                        ownerPhotoURL={url}
                                    />
                                </div>
                            }    
                        </div>
                    </div>
                </div> 
            </div>
                           
            


        )
    }
}
StoredListItem.propTypes = {
    item: PropTypes.object.isRequired,
    showFields: PropTypes.string.isRequired,
}

export default StoredListItem



// WEBPACK FOOTER //
// ./src/components/StoredListItem.js